<template>
  <div class="filter-matches">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.filter-matches {
  @include caption;
  display: flex;
  align-items: center;
  height: 2.5rem;
  padding: 0 measure(half);
  background-color: color(background-green-bar);
  border: 1px solid color(border-success-green);
}
</style>
